import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63d05856"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-content" }
const _hoisted_2 = { class: "card-image" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "card-title-row" }
const _hoisted_6 = { class: "card-title" }
const _hoisted_7 = { class: "card-subtitle" }
const _hoisted_8 = {
  key: 0,
  class: "card-details"
}

import { computed } from 'vue'
import { useWorkspaceStore } from '@/rd/WorkspaceStore'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { useSyncStore } from '@/rd/SyncStore'
import { workspaceTypeInfos } from '@/rd/ResearchDataModel'
import { LoadMode } from '@/util/AsyncData'
import { DateTimeUtil } from '@/util/LuxonUtil'
import UserLink from '@/manage/users/UserLink.vue'
import { useTokenManager } from '@/auth/TokenManager'
import { StatusInfo } from '@/util/AppUtil'


export default /*#__PURE__*/_defineComponent({
  __name: 'ResearchGroupCard',
  props: {
    dataGroupId: {},
    small: { type: Boolean },
    selectMode: { type: Boolean },
    selectedId: {},
    status: {}
  },
  emits: [
  "selected",
],
  setup(__props: any, { emit }) {

const props = __props;





const dataGroupStore = useDataGroupStore()
const workspaceStore = useWorkspaceStore()
const syncStore = useSyncStore()
const tokenManager = useTokenManager()

const memberStatusText = {
  owner: 'Owner',
  member: undefined,
}
const memberStatusStyle = {
  owner: 'warning',
  member: undefined,
}

const dataGroupRef = computed(() => dataGroupStore.getAsyncGroup(props.dataGroupId, LoadMode.EnsureLoaded)?.data)
const workspaceRef = computed(() => workspaceStore.getWorkspacesForGroups([dataGroupRef.value?.id], LoadMode.EnsureLoaded).at(0))
const logoRef = computed(() => workspaceTypeInfos.find(t => t.id == (workspaceRef.value?.dataFileBaseType ?? 'TestData'))?.icon)
const lastSyncRef = computed(() => syncStore.getAsyncSync(workspaceRef.value?.lastSyncId)) // loaded with workspace
const lastSyncDateTextRef = computed(() => {
  const relativeDate = lastSyncRef.value?.data?.createdDate
  return relativeDate ? `Last updated ${DateTimeUtil.toRelativePastDate(relativeDate)}` : "Never synced"
})
const cardClassesRef = computed(() => ({ 
  'card-small': props.small, 
  selected: props.selectedId == dataGroupRef.value?.id
}))

const memberStatusRef = computed(() => dataGroupRef.value?.ownerId == tokenManager.current.userId ? 'owner' : 'member')

const statusTextRef = computed(() => props.status?.text ?? memberStatusText[memberStatusRef.value])
const statusStyleRef = computed(() => props.status?.style ?? memberStatusStyle[memberStatusRef.value])


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["research-group-card shadow-sm", cardClassesRef.value])
  }, [
    (props.selectMode)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "overlay",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('selected')))
        }))
      : _createCommentVNode("", true),
    (dataGroupRef.value && !props.selectMode)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          class: "overlay",
          to: dataGroupRef.value.pageUrl
        }, null, 8, ["to"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", { src: logoRef.value }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(dataGroupRef.value?.name), 1),
          (statusTextRef.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["badge card-status", statusStyleRef.value])
              }, _toDisplayString(statusTextRef.value), 3))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createTextVNode(_toDisplayString(workspaceRef.value?.workspaceTypeInfo?.description) + " managed by ", 1),
          _createVNode(UserLink, {
            userId: dataGroupRef.value?.ownerId,
            class: "link-dark",
            dimmed: ""
          }, null, 8, ["userId"])
        ]),
        (!props.small)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(lastSyncDateTextRef.value), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})